import { fetchAllWorkflowsJson } from '@/features/rpa/recorder/api/rpa-recordings-http';
import { mapUserWorkflows } from '@/features/rpa/recorder/lib/map-user-workflows';
import { shouldPollUserWorkflows } from '@/features/rpa/recorder/lib/should-poll-user-workflows';
import { rpaUserWorkflowsQueryKey } from '@/features/rpa/recorder/query-keys';
import type {
  SkillSummary,
  UserWorkflowsResult,
} from '@/features/rpa/recorder/types/skill-summary';
import { useQuery } from '@tanstack/react-query';

const POLL_INTERVAL_MS = 5_000;
const STALE_TIME_MS = 30_000;

export function useUserWorkflows({
  enabled = true,
  keepPollingWhile,
}: {
  enabled?: boolean;
  /** Extra poll condition, checked against each fetched summary list. */
  keepPollingWhile?: (personal: readonly SkillSummary[]) => boolean;
} = {}) {
  return useQuery<UserWorkflowsResult>({
    enabled,
    queryKey: rpaUserWorkflowsQueryKey,
    queryFn: async () => mapUserWorkflows(await fetchAllWorkflowsJson()),
    staleTime: STALE_TIME_MS,
    refetchOnMount: 'always',
    refetchInterval: (query) => {
      const personal = query.state.data?.personal;
      const keepPolling = keepPollingWhile?.(personal ?? []) ?? false;
      return keepPolling || shouldPollUserWorkflows(personal) ? POLL_INTERVAL_MS : false;
    },
  });
}
